import { createClient } from '@supabase/supabase-js'

// Config comes from environment variables so dev/prod can point at different
// Supabase projects. The anon key is safe to expose publicly (security is
// enforced by Row Level Security in Postgres) — the fallbacks keep the app
// working if the env vars aren't set. Set REACT_APP_SUPABASE_* in Vercel.
const supabaseUrl =
  process.env.REACT_APP_SUPABASE_URL || 'https://dnneitdeqqsxrmxawjnk.supabase.co'
const supabaseKey =
  process.env.REACT_APP_SUPABASE_ANON_KEY ||
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRubmVpdGRlcXFzeHJteGF3am5rIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDg2MTI3MzIsImV4cCI6MjA2NDE4ODczMn0.k1hsu-eUydz-QwCioji3lf7pK431MoLbFkGx7iYHERs'

export const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: {
    flowType: 'pkce',        // safer auth-code (PKCE) flow for magic links
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
})
